import type { Section } from './types.js';

export interface SectionMeta {
  id: Section;
  /** i18n key for the tab label. */
  labelKey: string;
  icon: string;
  /** Sections whose generations run asynchronously (queued jobs, not streaming). */
  async: boolean;
  /** Whether section should only be visible to admins. */
  adminOnly?: boolean;
}

export const SECTION_META: SectionMeta[] = [
  { id: 'chat', labelKey: 'section.chat', icon: 'message-square', async: false },
  { id: 'image', labelKey: 'section.image', icon: 'image', async: false },
  { id: 'video', labelKey: 'section.video', icon: 'clapperboard', async: true },
  { id: 'video2', labelKey: 'section.video2', icon: 'clapperboard', async: true, adminOnly: true },
  { id: 'character', labelKey: 'section.character', icon: 'user-round', async: true },
  { id: 'audio', labelKey: 'section.audio', icon: 'music', async: true },
  { id: 'voice', labelKey: 'section.voice', icon: 'mic', async: true },
  { id: 'design', labelKey: 'section.design', icon: 'palette', async: false },
];

export function sectionMeta(section: Section): SectionMeta {
  const found = SECTION_META.find((item) => item.id === section);
  if (!found) throw new Error(`Unknown section: ${section}`);
  return found;
}

/** Buckets used by the sidebar to group conversations, newest first. */
export type DateBucket = 'today' | 'yesterday' | 'previous7Days' | 'previous30Days' | 'older';

export function dateBucket(date: Date, now: Date = new Date()): DateBucket {
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  const dayMs = 86_400_000;
  const time = date.getTime();
  if (time >= startOfToday) return 'today';
  if (time >= startOfToday - dayMs) return 'yesterday';
  if (time >= startOfToday - 7 * dayMs) return 'previous7Days';
  if (time >= startOfToday - 30 * dayMs) return 'previous30Days';
  return 'older';
}

export const DATE_BUCKET_ORDER: DateBucket[] = [
  'today',
  'yesterday',
  'previous7Days',
  'previous30Days',
  'older',
];

export function isSectionVisible(section: Section, isAdmin: boolean): boolean {
  const meta = sectionMeta(section);
  return !meta.adminOnly || isAdmin;
}
